import React, { useEffect, useState } from 'react';
import { Checkbox } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import { cloneDeep, findIndex } from 'lodash';
import { addTobeRemoved } from '../../store/actions/keywordActions';

const RemoveCheckBox = ({keywordId}) => {
  const dispatcher = useDispatch();
  const [isChecked, setIsChecked] = useState(false);
  const removalList = useSelector((state) => state.keywords.removals);

  useEffect( () => {
    const keywordPosition = currentKeywordPosition();
    setIsChecked(keywordPosition > -1);
  }, [removalList]);

  const currentKeywordPosition = () => {
    let cloneRemovalList = cloneDeep(removalList);
    return findIndex(cloneRemovalList, (keywordID) => { return keywordID === keywordId });
  }

  const onChange = () => {
    let cloneRemovalList = cloneDeep(removalList);
    const keywordPosition = currentKeywordPosition();
    if ( keywordPosition > -1 ) {
      cloneRemovalList.splice(keywordPosition, 1);
    } else {
      cloneRemovalList.push(keywordId);
    }
    dispatcher(addTobeRemoved(cloneRemovalList));
  }

  return (
    <Checkbox onChange={onChange} checked={isChecked} />
  )
}

export default RemoveCheckBox;